// extracted by mini-css-extract-plugin
export var label = "_gh-2";
export var slideContainer = "_gh-0";
export var slider = "_gh-1";